export const filterTriggerClass =
  "h-11 w-full rounded-xl data-[size=default]:h-11 border-dark-stroke-3 bg-dark-grey-50 px-3 text-dark-text-400 hover:bg-dark-stroke-3 data-[placeholder]:text-dark-text-300 [&_svg:not([class*='text-'])]:text-dark-text-300";
export const filterContentClass = "border-white/10 bg-dark-background-secondary text-white";
export const filterItemClass = "focus:bg-white/10 focus:text-white";

export const defaultTransactionFilters: TransactionFilterValues = {
  type: "all",
  status: "all",
  dateFrom: "",
  dateTo: "",
};

export const transactionStatusTabs = [
  { value: "all", label: "All" },
  { value: "pending", label: "Pending" },
  { value: "completed", label: "Completed" },
  { value: "failed", label: "Failed" },
];
